import { afterNextPaint } from "../js/afterNextPaint";
import { batch, createContext, createMemo, createResource, createSignal, untrack, useContext, createEffect } from "solid-js";
import { convertSizeUnit } from "../js/utils";
import { createStore } from 'solid-js/store';
import jsonLogic from "json-logic-js";

export const HeroFormContext = createContext({});

const deepCopy = (obj) => JSON.parse(JSON.stringify(obj))

const getCustomerSavedFit = () => {
  const productFitGroupId = fitGroupId?.product;
  return JSON.parse(sessionStorage.getItem(productFitGroupId) ?? null);
}

function roundPrice(price) {
  return parseFloat(parseFloat(price.toFixed(2)).toFixed(1)).toFixed(2);
}

const getFitData = () => {
  // MockData
  /*
  {
    "label": "Fit",
    "selected": "regular",
    "options": {
      "slim": {
        "id": "slim",
        "label": "Slim",
        "value": "Slim",
        "thumbnailSrc": ""
      },
      "regular": {
        "id": "regular",
        "label": "Regular",
        "value": "Regular",
        "thumbnailSrc": ""
      },
      "relaxed": {
        "id": "relaxed",
        "label": "Relaxed",
        "value": "Relaxed",
        "thumbnailSrc": ""
      }
    }
  } */
  const customerSavedFit = getCustomerSavedFit();
  const savedFit = customerSavedFit?.fit;

  const isFitAvailable = (fitHandleized) => 
    Object.values(fitObjInit.options).find(fit => fitHandleized == fit.id) != undefined;

  if(savedFit && isFitAvailable(handleize(savedFit))) {
    fitObjInit.selected = handleize(savedFit);
  }
  
  const [fit, setFit] = createSignal(fitObjInit)

  const handleFitSelection = (fitSelected) => {
    setFit(prevData => {
      const newData = deepCopy(prevData)
      newData.selected = fitSelected
      return newData
    });
  }

  return {
    fit,
    handlers: {
      handleFitSelection
    }
  }
}

const getStyleCustomizations = () => {
  // mockdata = {
  //   "pockets": {
  //     "label": "Pockets",
  //     "selected": "no-pockets",
  //     "options": {
  //       "no-pockets": {
  //         "id": "no-pockets",
  //         "label": "No Pockets",
  //         "value": "No Pockets",
  //         "thumbnailSrc": ""
  //       },
  //       "with-pockets": {
  //         "id": "with-pockets",
  //         "label": "With Pockets",
  //         "value": "With Pockets",
  //         "thumbnailSrc": ""
  //       }
  //     }
  //   },
  //   "sleeve": {
  //     "label": "Sleeve",
  //     "selected": "half-sleeve",
  //     "options": {
  //       "half-sleeve": {
  //         "id": "half-sleeve",
  //         "label": "Half Sleeve",
  //         "value": "Half Sleeve",
  //         "thumbnailSrc": ""
  //       },
  //       "full-sleeve": {
  //         "id": "full-sleeve",
  //         "label": "Full Sleeve",
  //         "value": "Full Sleeve",
  //         "thumbnailSrc": ""
  //       }
  //     }
  //   },
  //   "collar": {
  //     "label": "Collar",
  //     "selected": "spread-collar",
  //     "options": {
  //       "button-down-collar": {
  //         "id": "button-down-collar",
  //         "label": "Button Down Collar",
  //         "value": "Button Down Collar",
  //         "thumbnailSrc": ""
  //       },
  //       "spread-collar": {
  //         "id": "spread-collar",
  //         "label": "Spread Collar",
  //         "value": "Spread Collar",
  //         "thumbnailSrc": ""
  //       },
  //       "band-collar": {
  //         "id": "band-collar",
  //         "label": "Band Collar",
  //         "value": "Band Collar",
  //         "thumbnailSrc": ""
  //       }
  //     }
  //   }
  // }
  const [styleCustomizations, setStyleCustomizations] = createSignal(styleCustomizationsInit)

  const handleStyleSelection = (styleName, selectedOption) => {
    setStyleCustomizations(prevData => {
      const newData = JSON.parse(JSON.stringify(prevData));
      newData[styleName]['isCustomized'] = true;
      newData[styleName]['selected'] = selectedOption
      return newData
    });
  }

  const clearStyleCustomizations = (defaultStyles) => {
    setStyleCustomizations(prevData => {
      const newData = JSON.parse(JSON.stringify(prevData));
      
      for(const styleId of Object.keys(newData)) {
        const { selected, options } = newData[styleId];
        const chargeVariant = options[selected]?.chargeVariant;
        if(!chargeVariant) continue;
        
        const defaultStyle = defaultStyles[styleId];

        const defaultOption = options[defaultStyle];

        newData[styleId].selected = defaultStyle && !defaultOption?.chargeVariant ? defaultStyle : Object.keys(options)?.filter(optionId => !options[optionId]?.chargeVariant)?.[0]
      }

      return newData
    });
  }

  const handleStyleChangeByColor = (defaultStyles) => {
    if(defaultStyles == null) return;

    setStyleCustomizations(prevData => {
      const newData = JSON.parse(JSON.stringify(prevData));
      for(const styleId of Object.keys(newData)) {
        // if(newData[styleId].isCustomized) continue;
        const defaultStyle = defaultStyles[styleId];
        if(defaultStyle == undefined) continue;
        if(Object.keys(newData[styleId].options).includes(defaultStyle)) {
          newData[styleId].selected = defaultStyle;
        }
        newData[styleId].isCustomized = false;
      }
      
      return newData
    });
  }

  const handleOptionAvailabilityChange = (currentValues) => {
    const tempData = deepCopy(styleCustomizations());
    
    for(const [styleId, styleObj] of Object.entries(tempData)) {
      const selected = styleObj.selected;
      const options = styleObj.options;
      for(const [optionId, option] of Object.entries(options)) {
        const condition = option.condition;
        if(condition == null) {
          if(option.isEnabled != true) tempData[styleId].options[optionId].isEnabled = true;
          continue;
        }
  
        const flag = jsonLogic.apply(condition, currentValues);
        
        if(option.isEnabled == flag) continue;

        tempData[styleId].options[optionId].isEnabled = flag;
      }

      const isSelectedOptionEnabled = options[selected].isEnabled;
      if(isSelectedOptionEnabled) continue;

      const enabledOptions = Object.values(options).filter(option => option.isEnabled);
      tempData[styleId].selected = enabledOptions[0].id;
    }
    setStyleCustomizations(tempData);
  }

  return {
    styleCustomizations,
    handlers: {
      handleStyleSelection,
      handleOptionAvailabilityChange,
      handleStyleChangeByColor,
      clearStyleCustomizations
    }
  }
}

const getAccentCustomization = () => {
  const accentSettings = typeof(accentSettingsInit) != 'undefined' ? accentSettingsInit : {};

  const [accentFormData, setAccentFormData] = createStore({
    selected: accentSettings.options[0]?.id,
    option_inputs: accentSettings.options
      .reduce((prev, curr) => ({ 
        ...prev, 
        [curr.id]: Object.entries(curr.fields ?? {})
          .map(([fieldId, field]) => ({ id: fieldId, value: field.default ?? "" }))
          .reduce((prev, curr) => ({ ...prev, [curr.id]: curr.value }), {}) 
      }), {})
  })

  const handleAccentSelect = (optionId) => {
    setAccentFormData('selected', optionId);
  }

  const handleAccentInputsChange = (optionId, inputId, value) => {
    setAccentFormData('option_inputs', optionId, inputId, value);
  }

  const updateAccentInputs = (optionInputs) => {
    setAccentFormData('option_inputs', optionInputs)
  }

  const clearAccentCustomization = () => {
    if(accentSettings?.options?.length == 0) return;
    
    setAccentFormData('selected', accentSettings.options[0].id);
    // const firstField = Object.keys(accentSettings.options[1].fields)?.[0];
    // setAccentFormData('option_inputs', accentSettings.options[1].id, firstField, accentSettings.options[1].fields[firstField]?.default);
    setAccentFormData('option_inputs', accentSettings.options
      .reduce((prev, curr) => ({ 
        ...prev, 
        [curr.id]: Object.entries(curr.fields ?? {})
          .map(([fieldId, field]) => ({ id: fieldId, value: field.default ?? "" }))
          .reduce((prev, curr) => ({ ...prev, [curr.id]: curr.value }), {}) 
      }), {}));
  }

  return {
    accentSettings,
    accentFormData,
    handlers: {
      handleAccentInputsChange,
      handleAccentSelect,
      clearAccentCustomization,
      updateAccentInputs
    }
  }
}

const getUnitData = () => {
  const [currentUnit, setCurrentUnit] = createSignal(currentUnitInit);
  const baseUnit = baseUnitInit;

  const toggleCurrentUnit = () => {
    setCurrentUnit(prevUnit => prevUnit == "cm" ? "in" : "cm");
  }
  return {
    baseUnit,
    currentUnit,
    handlers: {
      toggleCurrentUnit
    }
  }
}

const getNavBarData = (styleCustomizations) => {
  const initialData = {
    "isVisible": false,
    "selected": Object.keys(styleCustomizations)[0] || "fit",
    "options": [
      {
        "label": "Fit"
      },
      {
        "label": "Size"
      },
      ...Object.values(styleCustomizations).map(style => {
        return {
          "label": style.label
        }
      })
    ]
  };

  // Object.entries(styleCustomizations).forEach((style, index) => {
  //   const [key, value] = style;

  //   initialData[key] = {
  //     "label": value.label,
  //     "isVisible": index == 0 ? true : false
  //   }
  // })

  // initialData['fit'] = {
  //   "label": "Fit",
  //   "isVisible": false
  // }

  // initialData['size'] = {
  //   "label": "Size",
  //   "isVisible": false
  // }

  const [navBarData, setNavBarData] = createSignal(initialData);

  const handleNavBarChange = (newSelected) => {
    setNavBarData(prevData => {
      const newData = JSON.parse(JSON.stringify(prevData));
      newData.selected = newSelected;
      return newData;
    })
  }

  const handleNavBarVisiblity = (isVisible) => {
    const body = document.getElementsByTagName('body')[0];
    body.style.overflow = isVisible ? 'hidden' : '';
    setNavBarData(prevData => {
      const newData = JSON.parse(JSON.stringify(prevData));
      newData.isVisible = isVisible != undefined ? isVisible : !newData.visible;
      return newData;
    })
  }

  return {
    navBarData,
    handlers: {
      handleNavBarChange,
      handleNavBarVisiblity
    }
  }
}

const getMeasurementOptionsData = (measurementOptionsInit) => {
  /*
  mockdata:
  {
    "selected": "",
    "options": {
      "standard-size": {
        "id": "standard-size",
        "label": "Standard Size",
        "customerMessage": "Some Message for Standard Size"
      },
      "send-fitting-garment": {
        "id": "send-fitting-garment",
        "label": "Send us a Shirt",
        "customerMessage": "Some Message for send garment"
      },
      "measure-it-yourself": {
        "id": "measure-it-yourself",
        "label": "Do it yourself",
        "customerMessage": "Some Message for measurement with best fitting shirt."
      }
    }
  }
   */

  const [measurementOptions, setMeasurementOptions] = createSignal(measurementOptionsInit)

  const handleMeasOptSelection = (selectedOption) => {
    setMeasurementOptions(prevData => {
      const newData = JSON.parse(JSON.stringify(prevData));
      newData['selected'] = selectedOption;

      return newData;
    })
  }

  return {
    measurementOptions,
    handlers: {
      handleMeasOptSelection
    }
  }
}

const getMeasurementOptionsDataV2 = (measurementOptionsV2Init) => {
  // const [measurementOptionsV2, setMeasurementOptionsV2] = createStore({
  // "selected": "",
  // "options": {
  // "made-to-measure": {
  // "id": "made-to-measure",
  // "label": "Made to Measure",
  // "customerMessage": "Some Message for made to measure"
  // },
  // "standard-size": {
  // "id": "standard-size",
  // "label": "Standard Size",
  // "customerMessage": "Some Message for Standard Size"
  // }
  // }
  // });
  const [measurementOptionsV2, setMeasurementOptionsV2] = createStore(measurementOptionsV2Init);

  const handleMeasOptSelectionV2 = (selectedOption) => {
    setMeasurementOptionsV2("selected", selectedOption);
  }

  return {
    measurementOptionsV2,
    handlers: {
      handleMeasOptSelectionV2
    }
  }
}

const getMadeToMeasureData = () => {
  // const madeToMeasureData = {
  //   "illustrationImgUrl": "https://cdn.discordapp.com/attachments/909693809040953344/1086207033633681468/Frame.png",
  //   "description": "Our team will get in touch with you to create your perfect fit. <br />If you are an existing customer, We will automatically retrieve your measurements.",
  //   "howItWorks": {
  //     "label": "How it works",
  //     "blogLink": "https://monksofmethod.com"
  //   }
  // }

  const madeToMeasureData = madeToMeasureOptionInit;

  return {
    madeToMeasureData
  }
}

const getStandardSizeData = (standardSizeDataInit) => {
  /* Mock Data
  {
    "measurementsToAvoid": [],
    "measurements": {
      "anchorGraded": {
        "waist": {
          "id": "waist",
          "label": "Waist",
          "thumbnailSrc": "https://cdn.shopify.com/s/files/1/0609/0453/8358/files/waist-pant-05.png?v=1642992952",
          "enabled": true,
          "selected": "30",
          "values": {
            "28": {
              "baseSize": "28",
              "displayName": {
                "slim": "15.0 inches (Size: 28)",
                "regular": "15.4 inches (Size: 28)",
                "regular-tapered": "15.4 inches (Size: 28)"
              }
            },
            "30": {
              "baseSize": "30",
              "displayName": {
                "slim": "15.9 inches (Size: 30)",
                "regular": "16.3 inches (Size: 30)",
                "regular-tapered": "16.3 inches (Size: 30)"
              }
            },
            "32": {
              "baseSize": "32",
              "displayName": {
                "slim": "16.9 inches (Size: 32)",
                "regular": "17.3 inches (Size: 32)",
                "regular-tapered": "17.3 inches (Size: 32)"
              }
            },
            "34": {
              "baseSize": "34",
              "displayName": {
                "slim": "17.9 inches (Size: 34)",
                "regular": "18.3 inches (Size: 34)",
                "regular-tapered": "18.3 inches (Size: 34)"
              }
            },
            "36": {
              "baseSize": "36",
              "displayName": {
                "slim": "18.9 inches (Size: 36)",
                "regular": "19.3 inches (Size: 36)",
                "regular-tapered": "19.3 inches (Size: 36)"
              }
            },
            "38": {
              "baseSize": "38",
              "displayName": {
                "slim": "19.9 inches (Size: 38)",
                "regular": "20.3 inches (Size: 38)",
                "regular-tapered": "20.3 inches (Size: 38)"
              }
            },
            "40": {
              "baseSize": "40",
              "displayName": {
                "slim": "20.9 inches (Size: 40)",
                "regular": "21.3 inches (Size: 40)",
                "regular-tapered": "21.3 inches (Size: 40)"
              }
            }
          },
          "measurementLinkedTo": null
        }
      },
      "nonAnchorUngraded": {
        "inseam": {
          "id": "inseam",
          "label": "Inseam",
          "thumbnailSrc": "",
          "enabled": true,
          "values": {
            "min": 28.0,
            "max": 38.0,
            "step": 0.5
          },
          "selected": "",
          "displayNameTemplate": "{{1}} inches",
          "measurementLinkedTo": "Inseam"
        }
      },
      "nonAnchorGraded": {}
    }
  }
   */

  const customerSavedFit = getCustomerSavedFit();

  if(Object.keys(standardSizeDataInit).length > 0) {
    const anchorKey = Object.keys(standardSizeDataInit.measurements.anchorGraded)[0];
    const sizesArr = Object.keys(standardSizeDataInit.measurements.anchorGraded[anchorKey].values)
  
    const savedSize = customerSavedFit?.size;
    const isSizeAvailable = (sizeHandleized) => sizesArr.find(s => s == sizeHandleized) != undefined;
    
    if(savedSize && isSizeAvailable(handleize(`${savedSize}`))) {
      standardSizeDataInit.measurements.anchorGraded[anchorKey].selected = handleize(`${savedSize}`);
    }

    if(customerSavedFit?.measurements) {
      for(const key of Object.keys(standardSizeDataInit.measurements.nonAnchorUngraded ?? {})) {
        const measurement = customerSavedFit.measurements[key];
        if(!measurement) continue;

        const values = measurement.split('/').map(m => m.replace('cm', '').replace('in', '').trim());
        standardSizeDataInit.measurements.nonAnchorUngraded[key].selected = handleize(`${baseUnitInit == "cm" ? values[0] : values[1]}`)
      }
    }
  }
  
  const [standardSizeData, setStandardSizeData] = createSignal(standardSizeDataInit);

  const handleStandardSizeChange = (type, id, selectedValue) => {
    setStandardSizeData(prevData => {
      const newData = JSON.parse(JSON.stringify(prevData));
      newData['measurements'][type][id]['selected'] = selectedValue;
      return newData;
    })
  }

  const handleAnchorGradedChange = (id, selectedValue) => {
    handleStandardSizeChange("anchorGraded", id, selectedValue);
    // setStandardSizeData(prevData => {
    //   const newData = JSON.parse(JSON.stringify(prevData));
    //   newData['measurements']['anchorGraded'][id]['selected'] = selectedValue;
    //   return newData;
    // })
  }

  const handleNonAnchorUngradedChange = (id, selectedValue) => {
    handleStandardSizeChange("nonAnchorUngraded", id, selectedValue);
    // setStandardSizeData(prevData => {
    //   const newData = JSON.parse(JSON.stringify(prevData));
    //   newData['measurements']['nonAnchorUngraded'][id]['selected'] = selectedValue;
    //   return newData;
    // })
  }

  const handleNonAnchorGradedChange = (id, selectedValue) => {
    handleStandardSizeChange("nonAnchorGraded", id, selectedValue);
  }

  return {
    standardSizeData,
    handlers: {
      handleAnchorGradedChange,
      handleNonAnchorUngradedChange,
      handleNonAnchorGradedChange
    }
  }
}

const getSendRefData = () => {
  /* MockData
   {
  "id": "send-fitting-garment",
  "radio": {
    "selected": "we-arrange-pickup",
    "options": {
      "we-arrange-pickup": {
        "id": "we-arrange-pickup",
        "heading": "We arrange a pick up!",
        "subheading": "Only available in limited pincodes",
        "isEnabled": true,
        "timeline": [
          "Place an order",
          "We arrange a pickup at your convenience",
          "Our courier partner picks it up",
          "We use the shirt to create a custom fit",
          "We return the garment with your order"
        ],
        "doesImpactVariantSelect": false
      },
      "send-us-garment": {
        "id": "send-us-garment",
        "heading": "Send us a shirt!",
        "subheading": "Sometimes the fastest way, send us a shirt",
        "isEnabled": true,
        "timeline": [
          "Ship us your shirt with your favorite courier",
          "We use the shirt to create a custom fit",
          "We return the garment with your order"
        ],
        "badge": { "text": "₹ 500 off!" },
        "doesImpactVariantSelect": true,
        "variant": {
          "measureType": "custom"
        }
      }
    }
  }
}

   */

  // if (typeof sendRefSettingsInit == 'undefined') return {
  //   sendRefData: null,
  //   handlers: {
  //     handleSendRefMethodSelection: null,
  //   },
  // }

  // const sendRefSettingsInit = {
  //   "id": "send-fitting-garment",
  //   "commonIntroduction": "We use the garment to create a custom fit and return it with your order",
  //   "radio": {
  //     "selected": "we-arrange-pickup",
  //     "options": {
  //       "we-arrange-pickup": {
  //         "id": "we-arrange-pickup",
  //         "message": "We will arange a pickup",
  //         "heading": "We arrange a pick up!",
  //         "subheading": "Only available in limited pincodes",
  //         "isEnabled": true,
  //         "timeline": [
  //           "Our courier partner will pick up the garment at your convenience",
  //           "Only available in limited pincodes"
  //         ],
  //         "doesImpactVariantSelect": false
  //       },
  //       "send-us-garment": {
  //         "id": "send-us-garment",
  //         "heading": "Send us a REFNOUN!",
  //         "message": "You will send us a garment",
  //         "subheading": "Sometimes the fastest way, send us a shirt",
  //         "isEnabled": true,
  //         "timeline": [
  //           "Ship us your REFNOUN with your favorite courier"
  //         ],
  //         "badge": {
  //           "text": "₹ 500 off!"
  //         },
  //         "doesImpactVariantSelect": true,
  //         "variant": {
  //           "measureType": "custom"
  //         }
  //       }
  //     }
  //   }
  // }

  const [sendRefData, setSendRefData] = createSignal(sendRefSettingsInit);

  const handleSendRefMethodSelection = (id) => {
    setSendRefData((prevData) => {
      const newData = JSON.parse(JSON.stringify(prevData));
      newData["radio"]["selected"] = id;
      return newData;
    });
  };

  return {
    sendRefData,
    handlers: {
      handleSendRefMethodSelection,
    },
  };
}

const getDIYData = () => {
  /* mockdata */
  // const diyDataInit = {
  //   "assuranceText": "We establish your measurement with best fitting shirt.",
  //   "measurements": {
  //     "shoulder": {
  //       "label": "Shoulder",
  //       "id": "shoulder",
  //       "value": {
  //         "cm": "41.0",
  //         "in": "16.1"
  //       },
  //       "min": {
  //         "cm": "20.0",
  //         "in": "7.9"
  //       },
  //       "max": {
  //         "cm": "70.0",
  //         "in": "27.6"
  //       },
  //       "isEnabled": true
  //     },
  //     "chest": {
  //       "label": "Chest",
  //       "id": "chest",
  //       "value": {
  //         "cm": "49.0",
  //         "in": "19.3"
  //       },
  //       "min": {
  //         "cm": "20.0",
  //         "in": "7.9"
  //       },
  //       "max": {
  //         "cm": "70.0",
  //         "in": "27.6"
  //       },
  //       "isEnabled": true
  //     },
  //     "collar-size": {
  //       "label": "Collar Size",
  //       "id": "collar-size",
  //       "value": {
  //         "cm": "36.0",
  //         "in": "14.2"
  //       },
  //       "min": {
  //         "cm": "20.0",
  //         "in": "7.9"
  //       },
  //       "max": {
  //         "cm": "70.0",
  //         "in": "27.6"
  //       },
  //       "isEnabled": true
  //     },
  //     "half-sleeve-length": {
  //       "label": "Half Sleeve Length",
  //       "id": "half-sleeve-length",
  //       "value": {
  //         "cm": "25.0",
  //         "in": "9.8"
  //       },
  //       "min": {
  //         "cm": "20.0",
  //         "in": "7.9"
  //       },
  //       "max": {
  //         "cm": "70.0",
  //         "in": "27.6"
  //       },
  //       "isEnabled": true
  //     },
  //     "full-sleeve-length": {
  //       "label": "Full Sleeve Length",
  //       "id": "full-sleeve-length",
  //       "value": {
  //         "cm": "54.0",
  //         "in": "21.3"
  //       },
  //       "min": {
  //         "cm": "20.0",
  //         "in": "7.9"
  //       },
  //       "max": {
  //         "cm": "70.0",
  //         "in": "27.6"
  //       },
  //       "isEnabled": false
  //     },
  //     "shirt-length": {
  //       "label": "Shirt Length",
  //       "id": "shirt-length",
  //       "value": {
  //         "cm": "71.0",
  //         "in": "28.0"
  //       },
  //       "min": {
  //         "cm": "20.0",
  //         "in": "7.9"
  //       },
  //       "max": {
  //         "cm": "70.0",
  //         "in": "27.6"
  //       },
  //       "isEnabled": true
  //     },
  //     "midsection": {
  //       "label": "Midsection",
  //       "id": "midsection",
  //       "value": {
  //         "cm": "45.0",
  //         "in": "17.7"
  //       },
  //       "min": {
  //         "cm": "20.0",
  //         "in": "7.9"
  //       },
  //       "max": {
  //         "cm": "70.0",
  //         "in": "27.6"
  //       },
  //       "isEnabled": true
  //     }
  //   }
  // }
  //  */


  const [diyData, setDiyData] = createSignal(diyDataInit);

  const { EMPTY, VALID, INVALID } = MEAS_VALIDATION_STATUS;

  /* mockdata */
  // const measurementStatusInit = {
  //   "shoulder": EMPTY,
  //   "chest": EMPTY,
  //   "collar-size": EMPTY,
  //   "half-sleeve-length": EMPTY,
  //   "full-sleeve-length": EMPTY,
  //   "shirt-length": EMPTY,
  //   "midsection": EMPTY
  // }
  //  */


  const [measurementStatus, setMeasurementStatus] = createSignal(measurementStatusInit)

  /* mockdata */
  // const measHtmVisibilityInit = {
  //   "shoulder": false,
  //   "chest": false,
  //   "collar-size": false,
  //   "half-sleeve-length": false,
  //   "full-sleeve-length": false,
  //   "shirt-length": false,
  //   "midsection": false
  // }
  // */

  const [measHtmVisibility, setMeasHtmVisibility] = createSignal(measHtmVisibilityInit)

  /* Mock data */
  // const measurementsInfoInit = {
  //   "shoulder": {
  //     "label": "Shoulder",
  //     "isAnchor": true,
  //     "enabled": true,
  //     "fit": ["*"],
  //     "size": {
  //       "slim": ["*"],
  //       "regular": ["*"],
  //       "relaxed": ["*"]
  //     },
  //     "customizations": {
  //       "pockets": ["*"],
  //       "collar": ["*"],
  //       "sleeve": ["*"]
  //     },
  //     "measurementOption": ["*"],
  //     "type": "graded",
  //     "youtubeId": "aSKch3iadHk",
  //     "htmVideoLink": "",
  //     "htmImgSrc": ""
  //   },
  //   "chest": {
  //     "label": "Chest",
  //     "isAnchor": false,
  //     "enabled": true,
  //     "fit": ["*"],
  //     "size": {
  //       "slim": ["*"],
  //       "regular": ["*"],
  //       "relaxed": ["*"]
  //     },
  //     "customizations": {
  //       "pockets": ["*"],
  //       "collar": ["*"],
  //       "sleeve": ["*"]
  //     },
  //     "measurementOption": ["*"],
  //     "type": "graded",
  //     "youtubeId": "aSKch3iadHk",
  //     "htmVideoLink": "",
  //     "htmImgSrc": ""
  //   },
  //   "collar-size": {
  //     "label": "Collar Size",
  //     "isAnchor": false,
  //     "enabled": true,
  //     "fit": ["*"],
  //     "size": {
  //       "slim": ["*"],
  //       "regular": ["*"],
  //       "relaxed": ["*"]
  //     },
  //     "customizations": {
  //       "pockets": ["*"],
  //       "collar": ["*"],
  //       "sleeve": ["*"]
  //     },
  //     "measurementOption": ["*"],
  //     "type": "graded",
  //     "youtubeId": "aSKch3iadHk",
  //     "htmVideoLink": "",
  //     "htmImgSrc": ""
  //   },
  //   "half-sleeve-length": {
  //     "label": "Half Sleeve Length",
  //     "isAnchor": false,
  //     "enabled": true,
  //     "fit": ["*"],
  //     "size": {
  //       "slim": ["*"],
  //       "regular": ["*"],
  //       "relaxed": ["*"]
  //     },
  //     "customizations": {
  //       "pockets": ["*"],
  //       "collar": ["*"],
  //       "sleeve": ["half-sleeve"]
  //     },
  //     "measurementOption": ["*"],
  //     "type": "graded",
  //     "youtubeId": "aSKch3iadHk",
  //     "htmVideoLink": "",
  //     "htmImgSrc": ""
  //   },
  //   "full-sleeve-length": {
  //     "label": "Full Sleeve Length",
  //     "isAnchor": false,
  //     "enabled": true,
  //     "fit": ["*"],
  //     "size": {
  //       "slim": ["*"],
  //       "regular": ["*"],
  //       "relaxed": ["*"]
  //     },
  //     "customizations": {
  //       "pockets": ["*"],
  //       "collar": ["*"],
  //       "sleeve": ["full-sleeve"]
  //     },
  //     "measurementOption": ["*"],
  //     "type": "graded",
  //     "youtubeId": "aSKch3iadHk",
  //     "htmVideoLink": "",
  //     "htmImgSrc": ""
  //   },
  //   "shirt-length": {
  //     "label": "Shirt Length",
  //     "isAnchor": false,
  //     "enabled": true,
  //     "fit": ["*"],
  //     "size": {
  //       "slim": ["*"],
  //       "regular": ["*"],
  //       "relaxed": ["*"]
  //     },
  //     "customizations": {
  //       "pockets": ["*"],
  //       "collar": ["*"],
  //       "sleeve": ["*"]
  //     },
  //     "measurementOption": ["*"],
  //     "type": "graded",
  //     "youtubeId": "aSKch3iadHk",
  //     "htmVideoLink": "",
  //     "htmImgSrc": ""
  //   },
  //   "midsection": {
  //     "label": "Midsection",
  //     "isAnchor": false,
  //     "enabled": true,
  //     "fit": ["*"],
  //     "size": {
  //       "slim": ["*"],
  //       "regular": ["*"],
  //       "relaxed": ["*"]
  //     },
  //     "customizations": {
  //       "pockets": ["*"],
  //       "collar": ["*"],
  //       "sleeve": ["*"]
  //     },
  //     "measurementOption": ["*"],
  //     "type": "graded",
  //     "youtubeId": "aSKch3iadHk",
  //     "htmVideoLink": "",
  //     "htmImgSrc": ""
  //   }
  // }
  // */

  const measurementsInfo = measurementsInfoInit

  const handleMeasurementChange = (measurementId, value, unit) => {
    setDiyData(prevData => {
      const newData = JSON.parse(JSON.stringify(prevData));
      const cmValue = convertSizeUnit(unit, "cm", value);
      const inValue = convertSizeUnit(unit, "in", value);
      newData['measurements'][measurementId]['value'] = {
        "cm": cmValue,
        "in": inValue,
      }

      return newData;
    })
  }

  const handleMinMaxChangeOnFit = (fit) => {
    const measurementFitObj = baseDimensionsMF.fit.find(f => handleize(f.name) == fit);
    const firstSizeObj = Object.values(measurementFitObj.size)[0];
    const lastSizeObj = Object.values(measurementFitObj.size)[Object.keys(measurementFitObj.size).length - 1];

    const { maxAnchorValue, minAnchorValue, maxNonAnchorVariance } = measurementFitObj;

    setDiyData(prevData => {
      const newData = JSON.parse(JSON.stringify(prevData));

      for (const measurementId of Object.keys(newData.measurements)) {
        const measurementDef = baseDimensionsMF.measurements.find(obj => handleize(obj.label) == measurementId)
        const firstMeasurementObj = firstSizeObj.find(obj => handleize(obj.label) == measurementId);
        const lastMeasurementObj = lastSizeObj.find(obj => handleize(obj.label) == measurementId);

        const referenceMeasurement = baseDimensionsMF.reference_measurement?.find(obj => handleize(obj.label) == measurementId)
        const isAnchor = firstMeasurementObj?.isAnchor
        let minValue = null;
        let maxValue = null;

        if (isAnchor) {
          minValue = minAnchorValue;
          maxValue = maxAnchorValue
        } else if (measurementDef.type == "reference") {
          minValue = referenceMeasurement.min;
          maxValue = referenceMeasurement.max;
        } else {
          minValue = firstMeasurementObj.value - maxNonAnchorVariance;
          maxValue = lastMeasurementObj.value + maxNonAnchorVariance
        }

        const calculateValue = (baseUnit, requiredUnit, value) => {
          return baseUnit == requiredUnit
            ? parseFloat(`${value}`).toFixed(1)
            : (
              baseUnit == "cm" ? (value / 2.54).toFixed(1) : (value * 2.54).toFixed(1)
            )
        }

        newData['measurements'][measurementId].min = {
          cm: calculateValue(baseUnitInit, 'cm', minValue),
          in: calculateValue(baseUnitInit, 'in', minValue),
        }

        newData['measurements'][measurementId].max = {
          cm: calculateValue(baseUnitInit, 'cm', maxValue),
          in: calculateValue(baseUnitInit, 'in', maxValue),
        }

      }

      return newData;
    })

    setMeasurementSchema(Object.values(diyData().measurements).filter((measurement) => measurement.isEnabled))
  }

  const handleMeasurementStatusChange = (id, status) => {
    setMeasurementStatus(prevData => {
      const newData = JSON.parse(JSON.stringify(prevData));
      newData[id] = status;
      return newData;
    })
  }

  const handleHtmVisibility = (id, state, isVideoAvailable) => {
    setMeasHtmVisibility(prevData => {
      const newData = JSON.parse(JSON.stringify(prevData));
      Object.keys(newData).forEach(key => newData[key] = false);
      if (isVideoAvailable)
        newData[id] = state;
      return newData;
    })
  }

  const handleMeasurementEnable = (newDiyData) => {
    batch(() => {
      setDiyData(newDiyData);
      setMeasurementSchema(Object.values(diyData().measurements).filter((measurement) => measurement.isEnabled))
    })

  }

  const [measurementSchema, setMeasurementSchema] = createSignal(Object.values(diyDataInit.measurements).filter((measurement) => measurement.isEnabled));
  const [formCursor, setFormViewCursor] = createSignal(0)
  const setFormCursor = (index) => { setFormViewCursor(index) }
  const currentUnitInit = "cm"
  const formDisplayValues = Object.fromEntries(Object.values(Object.values(diyDataInit.measurements)).map(m => [m.id, createSignal(m?.value?.[handleize(currentUnitInit ?? "")] ?? '')]))
  let formSequence = () => ['header', ...measurementSchema().map((measurement) => measurement.id || handleize(measurement.id)), 'footer'];

  const switchDisplayValueUnitsTo = (targetUnit) => {
    const sourceUnit = targetUnit === 'cm' ? 'in' : 'cm'
    batch(() => {
      for (const [key, valueSignal] of Object.entries(formDisplayValues)) {
        const [value, setValue] = valueSignal;
        if (value() != '') {
          const convertedValue = convertSizeUnit(sourceUnit, targetUnit, value());
          setValue(convertedValue)
        }
      }
    })

  }

  return {
    diyData,
    measurementStatus,
    MEAS_VALIDATION_STATUS,
    measurementsInfo,
    measHtmVisibility,
    diyFormUtils: {
      measurementSchema,
      formCursor,
      formSequence,
      formDisplayValues,
      handlers: {
        setMeasurementSchema,
        setFormCursor,
        switchDisplayValueUnitsTo
      }
    },
    handlers: {
      handleMeasurementChange,
      handleMeasurementStatusChange,
      handleHtmVisibility,
      handleMeasurementEnable,
      handleMinMaxChangeOnFit
    }
  }
}

const getSizeData = () => {

  /* mockdata
  {
    "label": "Size",
    "selected": "30",
    "options": [
      {
        "label": "28",
        "id": "28"
      },
      {
        "label": "30",
        "id": "30"
      },
      {
        "label": "32",
        "id": "32"
      },
      {
        "label": "34",
        "id": "34"
      },
      {
        "label": "36",
        "id": "36"
      },
      {
        "label": "38",
        "id": "38"
      },
      {
        "label": "40",
        "id": "40"
      }
    ],
    "badge": "Retrieve your measurements",
  }
   */
  const [sizeData, setSizeData] = createSignal(sizeDataInit);
  const [errorMessage, setErrorMessage] = createSignal();

  const {
    measurementOptions,
    handlers: measOptionHandlers
  } = getMeasurementOptionsData(measurementOptionsInit);

  const {
    measurementOptionsV2,
    handlers: measOptionV2Handlers
  } = getMeasurementOptionsDataV2(measurementOptionsV2Init);

  const {
    standardSizeData,
    handlers: standardSizeHandlers
  } = getStandardSizeData(standardSizeDataInit);


  const {
    sendRefData,
    handlers: sendRefHandlers
  } = getSendRefData()

  const {
    madeToMeasureData
  } = getMadeToMeasureData();

  const {
    diyData,
    measurementStatus,
    measHtmVisibility,
    diyFormUtils,
    MEAS_VALIDATION_STATUS,
    measurementsInfo,
    handlers: diyHandlers
  } = getDIYData()

  // const handleMeasOptSelection = (selectedOption) => {
  //   setSizeData(prevData => {
  //     const newData = JSON.parse(JSON.stringify(prevData));
  //     newData['measurementOptions']['selected'] = selectedOption;
  //     return newData;
  //   })
  // }

  const handleErrorMessage = (msg) => {
    setErrorMessage(msg || "");
  }

  return {
    sizeData,
    errorMessage,
    "standard-size": {
      standardSizeData,
      handlers: standardSizeHandlers
    },
    "measure-it-yourself": {
      diyData,
      measurementStatus,
      measurementsInfo,
      handlers: diyHandlers
    },
    "send-fitting-garment": {
      sendRefData,
      handlers: sendRefHandlers
    },
    measurementOptions,
    measurementOptionsV2,
    standardSizeData,
    sendRefData,
    diyData,
    madeToMeasureData,
    measurementStatus,
    measHtmVisibility,
    diyFormUtils,
    MEAS_VALIDATION_STATUS,
    measurementsInfo,
    handlers: {
      handleErrorMessage,
      ...measOptionHandlers,
      ...measOptionV2Handlers,
      ...standardSizeHandlers,
      ...sendRefHandlers,
      ...diyHandlers
    }
  }
}

// The gallery root (HeroClassic.jsx) mounts before the form root and both must agree on the selected
// colour, so the colour signal is created once per page and shared by every provider instance.
const getSharedColorSignal = (colorInitialObj) => {
  if (!window.__heroColorSignal) window.__heroColorSignal = createSignal(colorInitialObj);
  return window.__heroColorSignal;
}

export const getColorData = (colorInitialObj) => {

  if (colorInitialObj == undefined || colorInitialObj == null) return
  const [color, setColor] = getSharedColorSignal(colorInitialObj)

  const handleColorSelection = (selectedColorId) => {
    const variantId = productInfo.variants.standard?.[selectedColorId]?.id;

    // Only the selection changes; a shallow copy is enough and avoids deep-cloning every
    // colour's media on each swatch tap.
    setColor(prevData => ({ ...prevData, selected: selectedColorId }));

    // Nothing below is visible in the swatch-tap frame (URL bar, reviews, fabric table), so
    // it runs after that frame paints instead of inside the tap's INP window.
    afterNextPaint(() => {
      const url = new URL(window.location);
      url.searchParams.set('color', selectedColorId);
      url.searchParams.set('variant', variantId);
      try {
        window.history.replaceState({}, '', url);
      } catch (e) {
        console.error(e);
      }

      if (typeof(colorChangeHooks) != 'undefined') {
        for (const hook of colorChangeHooks) {
          hook({
            variantId
          })
        }
      }
    });
  }

  // a later provider (the form root) adopts whatever colour the visitor picked in the gallery root
  handleColorSelection(untrack(color).selected);

  return {
    color,
    handlers: {
      handleColorSelection
    }
  }
}

async function fetchProductImages() {

  const shopGraphQlUrl = 'https://monks-flat-staging.myshopify.com/api/graphql';
  const accessToken = 'f53e5d30c91b3aa58838c062a47be35d';
  const reqBody = `{
    productByHandle(handle: "${productInfo.handle}") {
      title
      images(first: 250) {
        edges {
          node {
            altText
            url(transform: {
              maxWidth: ${innerWidth}
            })
            height
            width
          }
        }
      }
    }
  }`

  const response = await fetch(shopGraphQlUrl, {
    method: "POST",
    headers: {
      "Content-Type": "application/graphql",
      "X-Shopify-Storefront-Access-Token": `${accessToken}`
    },
    body: reqBody
  });
  const res = await response.json();

  return res;
}

const getProductImagesByColor = () => {
  const [productImages] = createResource(() => fetchProductImages())

  const productImagesByColor = createMemo(() => {
    if (productImages.loading) return {}

    const { data: { productByHandle: product } } = productImages();
    const images = product.images?.edges?.map(edge => edge.node);

    const imagesByColor = {}

    images?.forEach(image => {
      const { altText, url } = image;
      if (!altText) return;

      const colorHandleized = handleize(altText);

      if (imagesByColor[colorHandleized] === undefined) imagesByColor[colorHandleized] = [];

      imagesByColor[colorHandleized].push(image);
    })

    return imagesByColor;
  })

  return productImagesByColor;
}

const getCustomer = () => {
  return {
    id: customerId,
    metafield: customerMetafield
  }
}

const getFormCompletionStatus = () => {
  return Object.freeze({
    EMPTY: -1,
    HALF_COMPLETE: 0,
    COMPLETE: 1
  })
}

const getSizeOptions = () => {
  const [sizeOption, setSizeOption] = createSignal(sizeOptionInit);

  const handleSizeOptionChange = (option) => {
    setSizeOption(option?.toUpperCase());
  }

  return {
    sizeOption,
    handlers: {
      handleSizeOptionChange
    }
  }
}

// Experiment / feature-flag getters (PostHog flags arrive asynchronously through the window hooks).
// Also used by the slim gallery context in HeroClassic.jsx.
export const createExperimentGetters = () => {
  const [experimentFlagSignal, setExperimentFlags] = createSignal({})
  const [featureFlagPayloads, setFeatureFlagPayloads] = createSignal({});

  if (typeof window.experimentFlags != 'undefined') {
    setExperimentFlags(window.experimentFlags)
    setFeatureFlagPayloads(window.featureFlagPayloads);
  } else {
    window.experimentFlagHooks?.push((experimentFlags) => {
      setExperimentFlags(experimentFlags)
    })
    window.featureFlagPayloadHooks?.push((payloads) => {
      setFeatureFlagPayloads(payloads)
    })
  }

  const getExperimentFlags = function (flagId) {
    return experimentFlagSignal()[flagId] || 'control'
  }

  const getFeatureFlagPayload = function (flagId) {
    return featureFlagPayloads()?.[flagId];
  }

  const isExperimentEnabled = (flagId) => {
    const payload = getFeatureFlagPayload(flagId);
    if(payload == undefined || payload?.enabled_pdp_handles == undefined) return true;

    return payload.enabled_pdp_handles?.includes(window.location.pathname.replace('/products/', ''))
  }

  const getFeatureFlagPayloadProp = (flagId, propId) => {
    const payload = getFeatureFlagPayload(flagId);
    if(payload == undefined || payload?.[propId] == undefined) return null;

    return payload[propId];
  }

  return { getExperimentFlags, getFeatureFlagPayload, isExperimentEnabled, getFeatureFlagPayloadProp };
}

export function HeroFormProvider(props) {
  const fit = getFitData();
  const unit = getUnitData();
  const styleCustomizations = getStyleCustomizations();
  const accentCustomizations = getAccentCustomization();
  const styles = untrack(styleCustomizations.styleCustomizations)
  const navBarData = getNavBarData(styles);
  const sizeSettings = getSizeData();
  const color = getColorData(colorInitialObj);
  const customer = getCustomer();
  const sizeOption = getSizeOptions();

  createEffect(() => {
    styleCustomizations.handlers.handleStyleChangeByColor(color.color().options[color.color().selected].defaultStyles)
  })

  const handleCustomizationChange = (diyData, measurementsInfo, customizationsInfo) => {
    const [updatedValue, isUpdated] = updateEnabled(diyData, measurementsInfo, customizationsInfo)

    if (isUpdated) {
      sizeSettings.handlers.handleMeasurementEnable(updatedValue);

    }
  }

  const handleColorChange = (currentValues) => {
    styleCustomizations.handlers.handleOptionAvailabilityChange(currentValues);

    const diyData = sizeSettings.diyData();
    const measurementsInfo = sizeSettings.measurementsInfo;
    const sizeCustomization = sizeSettings.sizeData().selected;
    const fitCustomization = fit.fit().selected;
    const customizationsInfo = styleCustomizations.styleCustomizations();
    const measurementOption = sizeSettings.measurementOptionsV2.selected;

    handleCustomizationChange(diyData, measurementsInfo, {
      "styleCustomizations": customizationsInfo,
      measurementOption,
      sizeCustomization,
      fitCustomization
    })
  }

  handleColorChange({ color: color.color().selected })

  window.heroFormHandlers = {
    handleSizeOptionChange: sizeOption.handlers.handleSizeOptionChange
  }

  const { getExperimentFlags, getFeatureFlagPayload, isExperimentEnabled, getFeatureFlagPayloadProp } = createExperimentGetters();

  let productRefNoun = typeof(PRODUCT_REFERENCE_NOUN) != 'undefined' ? PRODUCT_REFERENCE_NOUN : '';
  

  const value = {
    fit,
    fitGroupId,
    productInfo,
    unit,
    baseDimensionsMF,
    styleCustomizations,
    accentCustomizations,
    navBarData,
    sizeSettings,
    color,
    sizeOption,
    customer,
    PRODUCT_REFERENCE_NOUN: productRefNoun,
    heroSectionSettings,
    reviewProfilePictures,
    constants: {
      FORM_COMPLETION_STATUS: getFormCompletionStatus()
    },
    handlers: {
      handleCustomizationChange,
      handleColorChange
    },
    getters: {
      getExperimentFlags,
      getFeatureFlagPayload,
      isExperimentEnabled,
      getFeatureFlagPayloadProp
    },
    helpers: {
      roundPrice
    }
  }

  return (
    <HeroFormContext.Provider value={value}>
      {props.children}
    </HeroFormContext.Provider>
  )
}

export function useHeroForm() { return useContext(HeroFormContext); }